/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateLeadInfoRequestState } from './CreateLeadInfoRequestState';
import {
    CreateLeadInfoRequestStateFromJSON,
    CreateLeadInfoRequestStateFromJSONTyped,
    CreateLeadInfoRequestStateToJSON,
} from './CreateLeadInfoRequestState';
import type { FacilityServiceAreaStatus } from './FacilityServiceAreaStatus';
import {
    FacilityServiceAreaStatusFromJSON,
    FacilityServiceAreaStatusFromJSONTyped,
    FacilityServiceAreaStatusToJSON,
} from './FacilityServiceAreaStatus';

/**
 * 
 * @export
 * @interface FacilityServiceArea
 */
export interface FacilityServiceArea {
    /**
     * 
     * @type {string}
     * @memberof FacilityServiceArea
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityServiceArea
     */
    facility_id: string;
    /**
     * A 5-digit US ZIP code (e.g. "10001").
     * @type {string}
     * @memberof FacilityServiceArea
     */
    zip: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityServiceArea
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityServiceArea
     */
    state_id?: string;
    /**
     * 
     * @type {CreateLeadInfoRequestState}
     * @memberof FacilityServiceArea
     */
    state?: CreateLeadInfoRequestState;
    /**
     * 
     * @type {FacilityServiceAreaStatus}
     * @memberof FacilityServiceArea
     */
    status: FacilityServiceAreaStatus;
    /**
     * 
     * @type {string}
     * @memberof FacilityServiceArea
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityServiceArea
     */
    created_by_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityServiceArea
     */
    updated_by_user_id?: string;
    /**
     * Full name of the user who created this record, when known.
     * @type {string}
     * @memberof FacilityServiceArea
     */
    created_by_name?: string;
    /**
     * Full name of the user who last updated this record, when known.
     * @type {string}
     * @memberof FacilityServiceArea
     */
    updated_by_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof FacilityServiceArea
     */
    date_created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FacilityServiceArea
     */
    date_modified?: Date;
}

/**
 * Check if a given object implements the FacilityServiceArea interface.
 */
export function instanceOfFacilityServiceArea(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "zip" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function FacilityServiceAreaFromJSON(json: any): FacilityServiceArea {
    return FacilityServiceAreaFromJSONTyped(json, false);
}

export function FacilityServiceAreaFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityServiceArea {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'zip': json['zip'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state_id': !exists(json, 'state_id') ? undefined : json['state_id'],
        'state': !exists(json, 'state') ? undefined : CreateLeadInfoRequestStateFromJSON(json['state']),
        'status': FacilityServiceAreaStatusFromJSON(json['status']),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'created_by_user_id': !exists(json, 'created_by_user_id') ? undefined : json['created_by_user_id'],
        'updated_by_user_id': !exists(json, 'updated_by_user_id') ? undefined : json['updated_by_user_id'],
        'created_by_name': !exists(json, 'created_by_name') ? undefined : json['created_by_name'],
        'updated_by_name': !exists(json, 'updated_by_name') ? undefined : json['updated_by_name'],
        'date_created': !exists(json, 'date_created') ? undefined : (new Date(json['date_created'])),
        'date_modified': !exists(json, 'date_modified') ? undefined : (new Date(json['date_modified'])),
    };
}

export function FacilityServiceAreaToJSON(value?: FacilityServiceArea | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'zip': value.zip,
        'city': value.city,
        'state_id': value.state_id,
        'state': CreateLeadInfoRequestStateToJSON(value.state),
        'status': FacilityServiceAreaStatusToJSON(value.status),
        'notes': value.notes,
        'created_by_user_id': value.created_by_user_id,
        'updated_by_user_id': value.updated_by_user_id,
        'created_by_name': value.created_by_name,
        'updated_by_name': value.updated_by_name,
        'date_created': value.date_created === undefined ? undefined : (value.date_created.toISOString()),
        'date_modified': value.date_modified === undefined ? undefined : (value.date_modified.toISOString()),
    };
}

